import React, { useState } from "react";
import { Typography, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { getValByLang } from "../../../../utils/helpers";
import { useSelector } from "react-redux";
import AddToCartButton from "../../../../components/store/action/AddToCartButton";
import { Link as RouterLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { allLinks } from "../../../../utils/helpers";
import { setDetailsSelected } from "../../../../services/store/storeSlice";
import { setProductDetails } from "../../../../services/store/storeSlice";
import Translation from "../../../../utils/Translation";
import "./SaleDealsNew.css";

const FlashSaleSlider = ({ productDeals }) => {
  const { language } = useSelector((state) => state.store);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  
  const getSingleProduct = (product, details) => {
    dispatch(setDetailsSelected(details));
    dispatch(setProductDetails(product));
  };

  // Calculate items per page based on screen size
  const getItemsPerPage = () => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 768) return 1;
      if (window.innerWidth < 1200) return 2;
      return 3;
    }
    return 3;
  };

  const [itemsPerPage, setItemsPerPage] = useState(getItemsPerPage());

  // Update items per page on window resize
  React.useEffect(() => {
    const handleResize = () => {
      setItemsPerPage(getItemsPerPage());
      // Reset to first page if current page would be invalid
      const maxPage = Math.ceil(productDeals.length / getItemsPerPage()) - 1;
      if (currentPage > maxPage) {
        setCurrentPage(0);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [currentPage, productDeals.length]);

  const totalPages = Math.ceil(productDeals.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage;
  const visibleProducts = productDeals.slice(startIndex, startIndex + itemsPerPage);

  const goToNext = () => {
    setCurrentPage((prev) => (prev + 1) % totalPages);
  };

  const goToPrev = () => {
    setCurrentPage((prev) => (prev - 1 + totalPages) % totalPages);
  };

  const goToPage = (pageIndex) => {
    setCurrentPage(pageIndex);
  };
  // Auto-play functionality

  React.useEffect(() => {
    if (totalPages > 1) {
      const interval = setInterval(() => {
        goToNext();
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [currentPage, totalPages]);

  return (
    <Box className="deals-widget-container">
      {/* Header */}
      <Box className="deals-header">
        <Typography variant="h6" fontWeight="bold" className="deals-title">
          <Translation data="store.deals" />
        </Typography>
        
        {totalPages > 1 && (
          <Box className="deals-navigation">
            <IconButton 
              onClick={goToPrev} 
              className="nav-button prev-button"
              disabled={totalPages <= 1}
            >
              <ChevronLeft />
            </IconButton>
            <IconButton 
              onClick={goToNext} 
              className="nav-button next-button"
              disabled={totalPages <= 1}
            >
              <ChevronRight />
            </IconButton>
          </Box>
        )}
      </Box>

      {/* Products Grid */}
      <Box className="deals-grid">
        {visibleProducts.map((product) => (
          <Box key={product.id} className="deal-card">
            <Box
              component={RouterLink}
              to={`/${allLinks[5]}/` + getValByLang(product.slug, language)}
              onClick={() => getSingleProduct(product, product.details[0])}
              className="deal-image-container"
            >
              <img
                src={product.img}
                alt={getValByLang(product.name, language)}
                className="deal-image"
              />
            </Box>

            <Box className="deal-content">
              <Typography
                component={RouterLink}
                to={`/${allLinks[5]}/` + getValByLang(product.slug, language)}
                onClick={() => getSingleProduct(product, product.details[0])}
                className="deal-title"
              >
                {getValByLang(product.name, language)}
              </Typography>
              
              <Box className="deal-prices">
                <Typography className="original-price">
                  AED {product.details[0].default_price}
                </Typography>
                <Typography className="price">
                  AED {product.details[0].price}
                </Typography>
              </Box>
              
              <Typography className="availability">
                Available: {product.details[0].count - product.details[0].sold_amount}
              </Typography>

              <Box className="deal-actions">
                <AddToCartButton
                  product={product}
                  type="store"
                  quantity={1}
                  detail={product.details[0]}
                />
              </Box>
            </Box>
          </Box>
        ))}
      </Box>

      {/* Pagination Dots
      {totalPages > 1 && (
        <Box className="deals-pagination">
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              className={`pagination-dot ${index === currentPage ? 'active' : ''}`}
              onClick={() => goToPage(index)}
            />
          ))}
        </Box>
      )} */}
    </Box>
  );
};

export default FlashSaleSlider;
